export default {
  ERROR_FETCHING_ENTERPRISE_LEADS: "There was an error getting leads list",
};
